var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-count"},[_c('div',{staticClass:"icon"},[_c('FontAwesomeIcon',{attrs:{"icon":['far', 'map-marker-alt']}})],1),_vm._v(" "),_c('span',{attrs:{"data-testid":"count"}},[_vm._v(_vm._s(_vm.count))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc11fdc2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemCount.vue
// module id = 685
// module chunks = 0